// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "react-syntax-highlighter/refractor-import" + "." + "2d430659" + ".chunk.js";
};